import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/gallery.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/gallery.css');

export const GalleryDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      This would be pretty easy to do without flexbox, right? You would just set
      each Photo to have
      <code>display: inline-block</code>, and you would get the same basic
      layout.
    </p>

    <p>
      But inline-block elements can be tricky! They{' '}
      {
        <a
          href="https://css-tricks.com/fighting-the-space-between-inline-block-elements/"
          target="_blank"
          rel="noopener noreferrer"
        >
          interpret white-space in the markup
        </a>
      }{' '}
      in a way that introduces extra unwanted space between each item. You can
      get rid of this extra space, but you&rsquo;ll have to implement one of
      several workarounds.
    </p>

    <p>
      Fortunately, one of those workarounds is to just use flexbox! We need to
      use one new flexbox property called <code>flex-wrap</code> to do this.
      Normally, a flexbox container will try to fit all of its children onto one
      row.
      <code>flex-wrap</code> tells the container to wrap children onto
      subsequent rows instead.
    </p>
  </DemoPage>
);

GalleryDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/GalleryDemo.js